import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ItemServicoInserirComponent } from './item-servico-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: ItemServicoInserirComponent }
    ])],
    exports: [RouterModule]
})
export class ItemServicoInserirRoutingModule { }
